import { render, staticRenderFns } from "./DefaultContactForm.vue?vue&type=template&id=985ee466&"
import script from "./DefaultContactForm.vue?vue&type=script&lang=ts&"
export * from "./DefaultContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports